module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER 1")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('h2', {
    staticClass: "h2title"
  }, [_vm._v("Looking Good Is in Your Genes")]), _vm._v(" "), _c('p', {
    staticClass: "noindentia"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("I")]), _vm._v("f you’re like most women (including me, of course), over your lifetime, you’ve tried at least three to five different diets—without experiencing lasting success from any of them. The American dieting industry has blossomed into a multibillion-dollar-a-year behemoth that thrives on desperate women who will try anything to lower that number on their scales. Our cultural obsession with “dieting” makes us vulnerable to counting points or calories, having low-calorie meals delivered to our doors, or drinking “cleansing” drinks five times a day. Yet we’re still overweight, stressed out, unhealthy, and exhausted.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("The plain truth is that our modern lifestyle and the foods that are aggressively marketed to us are making our bodies and us sick, fat, bloated, and unrecognizable. It’s time to revisit our foundations as human animals and fuel our bodies in ways that are more in synch with the natural world. Sometimes in order to move forward, we have to be willing to look back. If you’ve learned this the hard way and have spent most of your life chasing one fad diet after another, I’ve got your number. But you need a game changer. It’s time to stop what you are doing and listen to your body. I have spent years looking at all the medical literature and data that show that ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("a diet high in lean proteins and low in unhealthy carbohydrates—yes, there are healthy carbs: vegetables and fruit—will keep us lean, healthy, and metabolically at our peak.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("My Paleo Chic diet offers a three-way mirror that lets you look at the effect of how you nourish yourself from all angles. You’ll look gorgeous from every angle, too.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Evolution Comes Full Circle")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Our species—or, more specifically, the human body—did not evolve to run on “fuels” such as chips, candy, and prepackaged cakes and meals. We aren’t equipped for highly processed foods that are loaded with bad fats, sugar, salt, and unpronounceable chemicals. In fact, our metabolic needs have changed little over the past ten thousand years, and our bodies—reliable systems that they are—still function best when they’re fueled with whole, unprocessed foods. In other words, Paleolithic people would not have done well on a diet of McDonald’s, either. Instead, our ancestors ate what was fresh and at hand: whether it was game, fruit, nuts, seeds, vegetables, or fish. We were hunters and gatherers, not fast-food chasers. Since there was no refrigeration way back then, our diets were primarily made up of fresh, nutrient-dense foods that were rich in vitamins, minerals, fiber, protein, and other crucial fuel generators.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m not saying that Paleolithic people were disease-free or lived longer than we do. (As a point of fact, the lifespan of Paleolithic people was pretty short, due to the “eat or be eaten” nature of human existence back then.) But we do know that Paleolithic people ate to live—which is all our bodies really need us to do. If we can remember this, and if we can strip away all of the temptations we face from engineered foods in pretty packaging and eat in order to live as well as we possibly can, we’ll approach food as medicine rather than as comfort, stress relief, drugs, or distractions, and we’ll be oh-so-much better and better-looking for it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("In other words, the simpler the better. That’s the core message and principle of the Paleo Chic diet.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Paleo Chic plan helps you to reboot your metabolism in ways that will do your body and mind more good than you can imagine: losing weight and gaining health. It’s all about learning to work with—not against—your body, to listen to its ancient, evolved wisdom. Instead, it’s about giving that awesome body of yours exactly what it needs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Paleo Chic diet is designed to support and enhance your genetic potential, and the net benefit is an improvement in your overall health and well-being. I know how it rolls. Because I’m often in a cocktail state of mind, I’ve found that the Paleo Chic plan allows me to “live hard, play hard,” and because of it, I feel (and look) better than I ever have.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Let’s be clear that I’m not perfect on it, and the truth is, I don’t want to be. I know I can go out with my friends for Saturday-night drinks and dinner and wake up the next day and hit the ground running because the Paleo Chic plan has taught me how to strike a balance between the big picture and the moments of decadent fun that we all need. I can let loose from time to time, without any of the guilt and without losing my sense of well-being. It’s a pretty gorgeous thing.")])]), _c('div', {
    staticClass: "sidebar"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "sidebartitle"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PALEO CHIC TERMS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenti"
  }, [_vm._v("Here’s a handy list of Paleo words and terms used throughout the book:")])]), _c('p', {
    staticClass: "noindenti1"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Carbohydrates.")]), _vm._v(" A component of foods that supplies energy (calories) to the body and has the greatest influence on your body’s ability to burn fat. The three broad categories of carbohydrates are sugars (also called simple carbohydrates), starches (also called complex carbohydrates), and fiber. Except for fiber and ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("resistant starch, which resists digestion and acts like dietary fiber, carbohydrates cause a higher and faster rise in blood glucose (sugar)—the body’s chief source of fuel—than proteins and fats do. Berries, apples, pears, spinach, kale, Brussels sprouts, sweet potatoes, winter squash, rutabagas, parsnips, turnips, and jicamas are all carbs that won’t tip the fat-burning scales.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "noindenti1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Cavewoman.")]), _vm._v(" Although the modern woman isn’t really a cavewoman, she can certainly eat like one. This means that she can hunt and gather locally grown produce, livestock, poultry, fish, and eggs. It also means she steers clear of processed foods filled with chemicals, artificial colors, flavors, sweeteners, and genetically modified organisms, or GMOs (explained on ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch04#page_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 51")]), _vm._v("). A cavewoman uses natural skin care and cleaning products, and lives as natural a life as she can under modern circumstances and the influence of technology and social norms.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenti1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Clean Eating.")]), _vm._v(" Clean eating is a lifestyle choice. When someone decides to “eat clean” she eliminates all processed foods and additives from her diet. In other words, you are choosing to eat whole, unrefined foods that have not been altered in any way and are as close to their natural state as possible. Nowadays, this means eating foods with five or fewer ingredients—all of which are pronounceable. Eating clean has many benefits, including weight loss, clear skin, improved energy, deep sleep, and a lean body composition.")]), _vm._v(" "), _c('p', {
    staticClass: "indenti"
  }, [_vm._v("Clean foods have many definitions in my home. The first is in its preparation. I wash all fruits and vegetables in a 3-to-1 solution of water to vinegar to remove pesticides from conventionally grown produce. I also wash under running water any foods wrapped in plastic, such as meat, poultry, and fish. I have my meats packaged in butcher paper whenever possible, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("sans")]), _vm._v(" plastic, and store food in glass containers with snap-on lids. Clean foods are minimally processed, meats are grass fed until they’re taken to market, and fruits and vegetables are grown "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("locally and/or organically—in other words, foods that walked, flew, swam, or grew from the ground (or trees).")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "noindenti1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Fats.")]), _vm._v(" Fats are both a major form of energy and a delicious addition to any food. Butter, heavy cream, olive and coconut oils, raw nuts and nut butters, and avocadoes all had me at hello. The right fats can combat PMS, migraines, coronary artery disease, diabetes, and obesity; hydrogenated oils like margarine that contain trans fats and poor-quality oils such as soybean, corn, canola, and cottonseed can make you inflamed, arthritic, obese, and depressed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenti1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Hormones.")]), _vm._v(" Hormones are biochemical messengers produced by the endocrine organs that control bodily functions such as growth, sexual development and reproduction, weight control, stress, and sleep. Cortisol, a stress hormone produced by the adrenal glands, can either build or break down muscle. Estrogen and progesterone regulate sexual development, menstrual cycles, and fertility; testosterone helps build lean muscle (yes, women’s bodies do make some testosterone); and dehydroepiandrosterone (DHEA) works in conjunction with the reproductive hormones to support fertility. Leptin and ghrelin regulate hunger and fullness. Growth hormone (GH) supports the production of lean muscle mass.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenti1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Metabolism.")]), _vm._v(" Metabolism encompasses all the chemical processes that occur within the body to keep us functioning. How well we eat, how active we are, and how many toxins we’re exposed to determine how well our metabolism runs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenti1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Neocarb.")]), _vm._v(" A neocarb is a carbohydrate introduced to the human diet within the last ten thousand years with the advent of modern agriculture. Think grains, legumes, and soy.")])]), _c('p', {
    staticClass: "noindenti1"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Paleocarb.")]), _vm._v(" Paleocarbs are carbohydrates that have existed since the beginning of time. They include vegetables, nuts, seeds, and ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("fruits. These carbs are considered healthy because they contain antioxidants and fiber and are relatively low in sugar.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "noindenti1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Protein.")]), _vm._v(" Proteins make up our cells, skin, hair, nails, and every organ and tissue in our bodies. The dietary protein we eat helps rebuild and repair the proteins in our bodies. Paleo-friendly proteins include pastured meats, poultry, fish, eggs, and wild game. Although our bodies can make some amino acids—organic compounds that are essential to cell growth and maintenance and to all metabolic processes—they also require that we eat protein from outside sources to get the rest.")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-728235ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 84
// module chunks = 0